@import "../../variables.scss";

.editcv {
  &__wrapper {
    background-color: white;
    position: fixed;
    z-index: 1000;
    height: 100%;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    top: 0px;
  }
  &__selected {
    border: 1px dashed #565656;
    background-color: #eaeaea;
    border-radius: 4px;
    width: 284px;
  }
  &__title {
    font-weight: bold;
    letter-spacing: 0.6px;
    font-size: 32px;
    line-height: 38px;
    @media (max-width: $size-sm) {
      font-size: 20px;
      line-height: 24px;
    }
  }
  &__description {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.3375px;
  }
  &__smalldescription {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.3px;
  }
  &__icon {
    width: 22.5px;
    height: 28px;
    position: relative;
  }
  &__icontext {
    position: absolute;
    color: white;
    z-index: 1;
    font-weight: bold;
    font-size: 8px;
    line-height: 14px;
    left: 3px;
    bottom: 0;
  }
  &__filename {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.6px;
    margin-top: 0.7rem;
    margin-bottom: 1rem;
    display: block;
    width: 100%;
  }
  &__changefile {
    font-weight: bold;
    font-size: 16px;
    color: black;
    &:hover {
      color: black;
    }
  }
  &__date {
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.3375px;
  }
}
